"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var featurePanelDefaults = {
  buttonMarginTop: 'base',
  buttonVariant: 'primary',
  copyFontSize: 'medium',
  primaryCopyColumnWidth: [12, null, 5, 5],
  primaryMediaColumnWidth: [12, null, 7, 5],
  titleFontSize: 'medium',
  // Secondary Feature Panel
  backgroundColorSecondary: 'offwhite',
  contentWrapperPaddingSecondaryX: [null, null, 'xxxlarge'],
  contentWrapperPaddingSecondaryY: ['large', null, 'base'],
  secondaryPadding: [null, null, 'xxlarge'],
  // Tertiary Feature Panel
  backgroundColorTertiary: 'accent1',
  marginTopTertiary: ['large', null, 'xlarge']
};
var featurePanel = {
  horizon: _objectSpread({}, featurePanelDefaults),
  dcl: _objectSpread(_objectSpread({}, featurePanelDefaults), {}, {
    backgroundColorSecondary: 'greymid'
  }),
  money2020: _objectSpread(_objectSpread({}, featurePanelDefaults), {}, {
    // Secondary Feature Panel
    contentWrapperPaddingSecondaryX: null,
    contentWrapperPaddingSecondaryY: ['base', null, null],
    secondaryPadding: [null, null, 'base'],
    // Tertiary Feature Panel
    backgroundColorTertiary: 'white'
  }),
  lionsCreativity: _objectSpread(_objectSpread({}, featurePanelDefaults), {}, {
    buttonMarginTop: ['large', null, 'xlarge'],
    copyFontSize: 'small',
    primaryCopyColumnWidth: [12, null, 6, 6],
    primaryMediaColumnWidth: [12, null, 6, 6],
    titleFontSize: 'medium',
    // Secondary Feature Panel
    backgroundColorSecondary: 'greymid',
    contentWrapperPaddingSecondaryX: null,
    contentWrapperPaddingSecondaryY: ['base', null, null],
    secondaryPadding: 'base',
    // Tertiary Feature Panel
    backgroundColorTertiary: 'white',
    marginTopTertiary: ['large', null, 'xxxlarge']
  })
};
var _default = featurePanel;
exports.default = _default;